<template>
  <div class="text-center">
    <div v-for="(row, index) in innerOptions" :key="index">
      <template v-for="(option, index) in row">
        <div v-if="option.value !== null" :key="index"
             :class="['d-inline-flex', 'space', 'square', 'my-1', ...option.class, innerSelected.includes(option.value) ? 'selected' : null, option.disabled ? 'disabled' : null]"
             :style="{width: ((17 * option.size) - 2) + 'vw'}"
             :disabled="option.disabled"
             @click="!option.disabled && select(option.value)" v-html="option.text">
        </div>
        <div v-else :key="index"
             :class="['d-inline-flex', 'space', 'my-1', ...option.class]"
             :style="{width: ((17 * option.size) - 2) + 'vw'}"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectWithButtons',
  props: {
    options: {required: true},
    rowSize: {default: Infinity},
    selected: {default: () => []}
  },
  computed: {
    innerSelected() {
      return Array.isArray(this.selected) ? this.selected : [this.selected];
    },
    innerOptions() {
      let tempOpts = this.options;
      if (!(tempOpts instanceof Array)) {
        tempOpts = Object.keys(tempOpts).map(key => {
          return {value: key, text: tempOpts[key]};
        });
      }

      tempOpts = tempOpts.map(value => {
        if (value === null) {
          value = {value: null};
        }
        return {
          value: value.value !== undefined ? value.value : value,
          text: value.text !== undefined ? value.text : value,
          size: value.size ?? 1,
          class: value.class ?? [],
          disabled: value.disabled ?? false
        };
      });

      const ret = [];
      let row = [];
      let cellCounter = 0;
      for (const opt of tempOpts) {
        if (cellCounter + opt.size > this.rowSize) {
          ret.push(row);
          row = [];
          cellCounter = 0;
        }
        cellCounter += opt.size;
        row.push(opt);
      }
      //Flush remaining incomplete row
      if (row.length > 0) {
        ret.push(row);
      }
      return ret;
    }
  },
  methods: {
    select(option) {
      this.$emit('click', option);
    }
  }
};
</script>

<style scoped>
.space {
  height: 15vw;
  margin-left: 1vw;
  margin-right: 1vw;
}

.square {
  color: #1e3a5f;
  font-size: 9vw;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1.5px solid #c5d3e8;
  border-radius: 0.625rem;
  box-shadow: 0 1px 4px rgba(30, 58, 95, 0.07);
  transition: background-color 0.12s, border-color 0.12s, box-shadow 0.12s;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.square:active {
  box-shadow: none;
  background-color: #f0f4f8;
}

.selected {
  background-color: #dbeafe;
  border-color: #1e3a5f;
  color: #1e3a5f;
  box-shadow: 0 2px 8px rgba(30, 58, 95, 0.18);
}

.disabled {
  background-color: #e8ecf1;
  color: #c8d0db;
  border-color: #dde3ed;
  pointer-events: none;
  opacity: 0.35;
}
</style>